import type { PropType } from "vue";

import { Color, ColorVariant, Gradient, Size } from "@/abc-dsk/options";

// TODO It would be awesome if these can be converted to types, once all components are converted to TS.

export const ariaLabel = {
  type: String,
  default: undefined
};

export const color = {
  type: String as PropType<Color>,
  default: Color.Primary
};

export const colorVariant = {
  type: String as PropType<ColorVariant>,
  default: undefined
};

export const gradient = {
  type: String as PropType<Gradient>,
  default: undefined
};

export const disabled = {
  type: Boolean,
  default: false
};

export const size = {
  type: String as PropType<Size>,
  default: Size.Md
};
